<template>
  <button
    class="answer"
    type="button"
    @click="nextQuestion ? selectAnswer('next') : selectAnswer('results')"
  >
    <div class="answer__container">
      <div class="answer__image" v-if="image"></div>

      <div class="answer__text">
        <b class="answer__title">{{ title }}</b>
        <div v-html="text"></div>
      </div>
    </div>
  </button>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: false,
    },
    image: {
      type: String,
      required: false,
    },
    nextQuestion: {
      type: Number,
      required: false,
      default: null,
    },
    results: {
      type: Array,
      required: false,
      default: null,
    },
  },
  methods: {
    selectAnswer(type) {
      if (type === 'next') {
        this.$emit('selectAnswer', 'next', this.nextQuestion);
      } else if (type === 'results') {
        this.$emit('selectAnswer', 'results', this.results);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.answer {
  background-color: $color-primary;
  width: 100%;
  min-height: 78px;
  margin: 0 0 20px 0;
  padding: 0;
  position: relative;
  cursor: pointer;
  outline: 0;
  text-align: left;
  border: 0;

  &:last-child {
    margin-bottom: 0;
  }

  &::after {
    display: block;
    content: '►';
    position: absolute;
    right: 25px;
    top: 50%;
    color: $color-contrast-dark;
    transform: translateY(-50%);
  }

  &:hover,
  &:focus {
    background-color: $color-primary-light;
  }

  &:active {
    background-color: $color-primary;
  }

  &__container {
    display: flex;
    align-items: center;
  }

  &__image {
    background-color: $color-white;
    height: 90px;
    flex-basis: 90px;
  }

  &__text {
    padding: 15px 20px;
    flex-basis: auto;
  }

  &__title {
    display: block;
  }
}
</style>
